import React from 'react';
import 'react-multi-carousel/lib/styles.css';
import { ASSET_URL } from '../../../../env/Configurations';
import './Large-Image-Component-With-Background.scss';

const LargeImageComponentWithBackgroundPreview = (props) => {
  const { config } = props;

  return (
    <div className='large-image-with-background'>
      {config && (
        <div>
          <div className='preview-title'>{config?.titleH1 ? config?.titleH1 : 'H1 Title'}</div>
          {!config.isVideo && (
            <div
              style={{
                backgroundColor: config?.backgroundColor || '#8f8f8f',
              }}
              className={`large-image-with-background-box ${
                config?.shadowOverlay ? 'shadowed-img' : ''
              }`}
            >
              <div
                className='d-flex align-items-center justify-content-center h-100 large-image-with-background-image-container'
                style={
                  config?.imgURL
                    ? {
                        backgroundImage: 'url(' + ASSET_URL + config?.imgURL + ')',
                        backgroundSize: 'cover',
                      }
                    : {}
                }
              >
                <div
                  className='slide-title'
                  style={config?.imgURL ? { color: 'white' } : { color: 'black' }}
                >
                  {config?.titleH3 ? config?.titleH3 : 'H3 Title'}
                </div>
              </div>
            </div>
          )}
          {config?.isVideo && (
            <div className={`${config?.shadowOverlay ? 'shadowed-img' : ''}`}>
              <div className='video-container'>
                <video
                  width={'100%'}
                  height={'100%'}
                  autoPlay
                  loop={config?.loopPlayBack}
                  preload='auto'
                  src={config?.videoURL}
                  muted
                />

                <div
                  className='title-label'
                  style={config?.videoURL ? { color: 'white' } : { color: 'black' }}
                >
                  {config?.titleH3 ? config?.titleH3 : 'H3 Title'}
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default LargeImageComponentWithBackgroundPreview;
